module.exports = __webpack_public_path__ + "d559e0783388ad3798abc3778894bdb3.svg";